import { render, staticRenderFns } from "./shebeiList.vue?vue&type=template&id=48f569d2&scoped=true&"
import script from "./shebeiList.vue?vue&type=script&lang=js&"
export * from "./shebeiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f569d2",
  null
  
)

export default component.exports